import { render, staticRenderFns } from "./AppBarMarquee.vue?vue&type=template&id=36c1bb59&scoped=true"
import script from "./AppBarMarquee.vue?vue&type=script&lang=js"
export * from "./AppBarMarquee.vue?vue&type=script&lang=js"
import style0 from "./AppBarMarquee.vue?vue&type=style&index=0&id=36c1bb59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1bb59",
  null
  
)

export default component.exports